import { dateToTimestamp } from 'shared/helpers/parsers/date';
import { removeCommasAndParse } from 'shared/helpers/parsers/text';

export const parseUpdateDraftPoolPaymentData = ({ payment, settlement, financeCharges }) =>
  Object.entries({
    relatedCompany: payment.relatedCompany.value,
    fundsType: payment.fundsType.value,
    additionalInfo: payment.additionalInfo,
    requestedFinalPaymentDate: dateToTimestamp(payment.requestedFinalPaymentDate),
    outstandingBalanceApplied: removeCommasAndParse(settlement.outstandingBalanceApplied),
    pricePerOuncePt: removeCommasAndParse(settlement.pricePerOuncePt),
    pricePerOuncePd: removeCommasAndParse(settlement.pricePerOuncePd),
    pricePerOunceRh: removeCommasAndParse(settlement.pricePerOunceRh),
    charges:
      financeCharges.charges?.map(charge => ({
        relatedLot: charge.relatedLot?.value,
        financeCharge: removeCommasAndParse(charge.financeCharge),
        ...(charge.financeRate && { financeRate: removeCommasAndParse(charge.financeRate) }),
      })) || [],
  }).reduce((acc, [key, value]) => (value || value === 0 ? { ...acc, [key]: value } : acc), {});
